export class ProductService {

  public ProductModel: InterACT.Interfaces.Catalogues.Product = <any>{};
  public products: Array<InterACT.Interfaces.Catalogues.Product> = [];
  public totalCount = 0;
  public perPageCount = 15;
  public currentPage = 1;
  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Catalogues.ProductsResponse | InterACT.Interfaces.Catalogues.ProductResponse>>;

  constructor($resource: ng.resource.IResourceService) {
    this.resource = $resource(
      'api/catalogues/:catalogueId/products/:productId',
      undefined,
      { edit: { method: 'PATCH' }, update: { method: 'PUT' } }
    );
  }

  public create(catalogueId: string, data: InterACT.Interfaces.Catalogues.Product) {
    this.deleteUnusedFields(data);

    return this.resource.save({ catalogueId: catalogueId }, data).$promise.then(() => {
      return this.getList(catalogueId);
    });
  }

  public edit(catalogueId: string, productId: number, data: InterACT.Interfaces.Catalogues.Product) {
    const options = {
      catalogueId: catalogueId,
      productId: productId
    };

    return (<any>this.resource).edit(options, data).$promise;
  }

  public update(catalogueId: string, productId: number, data: InterACT.Interfaces.Catalogues.Product) {
    this.deleteUnusedFields(data);

    const options = {
      catalogueId: catalogueId,
      productId: productId
    };

    return (<any>this.resource).update(options, data).$promise;
  }

  public getProduct(catalogueId: string, productId: number, options) {
    if (!angular.isObject(options)) {
      options = {};
    }

    options.catalogueId = catalogueId;
    options.productId = productId;

    return this.resource.get(options).$promise.then((resource) => {
      return (<InterACT.Interfaces.Catalogues.ProductResponse>resource).product;
    });
  }

  public getList(catalogueId: string, page?: number, perPageCount?: number, options?: any) {
    let baseOptions;

    if (angular.isDefined(page)) {
      this.currentPage = page;
    } else {
      this.currentPage = 1;
    }

    if (angular.isDefined(perPageCount)) {
      this.perPageCount = perPageCount;
    }

    baseOptions = {
      expand: false,
      page: this.currentPage,
      offset: (this.currentPage - 1) * this.perPageCount,
      limit: this.perPageCount,
      catalogueId: catalogueId
    };

    return this.resource.get(_.merge(baseOptions, options)).$promise.then((resource) => {
      this.products = (<InterACT.Interfaces.Catalogues.ProductsResponse>resource).products;
      this.totalCount = (<InterACT.Interfaces.Catalogues.ProductsResponse>resource).meta.totalCount;
      return resource;
    });
  }

  public getListAfterUpdate(catalogueId: string) {
    if (this.products.length === 0) {
      if (this.currentPage > 1) {
        return this.getList(catalogueId, this.currentPage - 1, this.perPageCount);
      }
    } else {
      return this.getList(catalogueId, this.currentPage, this.perPageCount);
    }
  }

  public remove(catalogueId: string, productId: number) {
    const options: any = {
      catalogueId: catalogueId,
      productId: productId
    };

    return this.resource.delete(options).$promise.then(() => {
      return this.getListAfterUpdate(catalogueId);
    });
  }

  private deleteUnusedFields(data: InterACT.Interfaces.Catalogues.Product) {

    ["operator","service","zones","entitlements"].forEach(element => {
      if (data.fields[element] && Array.isArray(data.fields[element])) {
        data.fields[element] = data.fields[element].filter((entry:any) => entry.link);
  
        if (data.fields[element].length === 0) {
          delete data.fields[element];
        }
      }
    });
  }
}
